
import { BASE_URL } from "./Constants";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Papa from "papaparse";
import React, { useState, useEffect } from "react";
import sampleTemplate from "./templates/Written_Exam_Format.csv";

const UploadWrittenQuestion = () => {

  const [csvFile, setCsvFile] = useState(null);
  const [writtenData, setWrittenData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const [duplicateList, setDuplicateList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentData = writtenData.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const totalPages = Math.ceil(writtenData.length / itemsPerPage);

  const fetchWrittenData = async () => {
    try {
      setLoadingData(true);

      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `${BASE_URL}get_written_data`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const res = await response.json();

      if (res.status) {
        setWrittenData(res.data);
      }
    } catch (error) {
      console.error("Fetch written data error:", error);
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    fetchWrittenData();
  }, []);

  /* ================= CSV UPLOAD ================= */
  const handleCSVUpload = () => {

    if (!csvFile) {
      alert("Please select CSV file");
      return;
    }

    Papa.parse(csvFile, {
      header: true,
      skipEmptyLines: true,
      complete: async (results) => {
        try {
          const token = localStorage.getItem("authToken");

          const response = await fetch(
            `${BASE_URL}upload_written_csv`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
              body: JSON.stringify({
                data: results.data,
              }),
            }
          );

          const res = await response.json();

          if (res.status) {

            const result = res.data;

            setDuplicateList(result.duplicates || []);

            if (result.inserted_count > 0) {
              alert(`✅ ${result.inserted_count} records uploaded`);
              fetchWrittenData();
            }

            if (result.duplicate_count > 0) {
              alert(`⚠ ${result.duplicate_count} duplicate questions found`);
            }

            setCsvFile(null);
          } else {
            alert("Upload Failed");
          }
        } catch (error) {
          console.error("Upload Error:", error);
        }
      },
    });
  };

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />

        <div className="main-panel">
          <div className="content-wrapper">

            <div className="card shadow-sm border-0">
              <div className="card-body">

                <h4 className="fw-bold mb-4">
                  Upload Written Questions (CSV)
                </h4>

                <div className="mb-3">
                  <a
                    href={sampleTemplate}
                    download="sample_questions_template.csv"
                    className="btn btn-outline-success"
                  >
                    ⬇ Download Sample Template
                  </a>
                </div>

                {/* ===== CSV Upload ===== */}
                <div className="row">
                  <div className="col-md-6">
                    <input
                      type="file"
                      accept=".csv"
                      className="form-control"
                      onChange={(e) =>
                        setCsvFile(e.target.files[0])
                      }
                    />
                  </div>

                  <div className="col-md-3">
                    <button
                      className="btn btn-primary w-100"
                      onClick={handleCSVUpload}
                    >
                      Upload CSV
                    </button>
                  </div>
                </div>

              </div>
            </div>

            {duplicateList.length > 0 && (
              <div className="card shadow-sm border-0 mt-4">
                <div className="card-body">

                  <h5 className="fw-bold text-danger mb-3">
                    Duplicate Questions Skipped
                  </h5>

                  <ul className="list-group">
                    {duplicateList.map((q, index) => (
                      <li key={index} className="list-group-item">
                        {q}
                      </li>
                    ))}
                  </ul>

                </div>
              </div>
            )}

            <div className="card shadow-sm border-0 mt-4">
              <div className="card-body">

                <h5 className="fw-bold mb-3">
                  Written Exam Data
                </h5>

                {loadingData ? (
                  <p>Loading data...</p>
                ) : (
                  <div className="table-responsive">
                    <table
                      className="table table-bordered table-hover"
                      style={{ tableLayout: "fixed", width: "100%" }}
                    >
                      <thead className="table-dark">
                        <tr>
                          <th style={{ width: "60px" }}>ID</th>
                          <th style={{ width: "120px" }}>Emp ID</th>
                          <th style={{ width: "200px" }}>Email</th>
                          <th style={{ width: "260px" }}>Question</th>
                          <th style={{ width: "180px" }}>Correct Answer</th>
                          <th style={{ width: "180px" }}>Employee Answer</th>
                          <th style={{ width: "90px" }}>Score</th>
                          <th style={{ width: "180px" }}>Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {writtenData.length > 0 ? (
                          currentData.map((item) => (
                            <tr key={item.id}>
                              <td>{item.id}</td>
                              <td>{item.emp_id}</td>
                              <td>{item.email}</td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere"
                                }}
                              >
                                {item.question}
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere"
                                }}
                              >
                                {item.correct_answer}
                              </td>
                              <td
                                style={{
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  overflowWrap: "anywhere"
                                }}
                              >
                                {item.emp_answer}
                              </td>
                              <td>
                                <span
                                  className={`badge ${item.score === "1"
                                    ? "bg-success"
                                    : "bg-danger"
                                    }`}
                                >
                                  {item.score}
                                </span>
                              </td>
                              <td>
                                {new Date(item.submitted_date).toLocaleString()}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    {/* ===== Pagination ===== */}
                    <div className="d-flex justify-content-between align-items-center mt-3">

                      {/* Items Per Page */}
                      <div>
                        <select
                          className="form-select"
                          style={{ width: "120px" }}
                          value={itemsPerPage}
                          onChange={(e) => {
                            setItemsPerPage(Number(e.target.value));
                            setCurrentPage(1);
                          }}
                        >
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </select>
                      </div>

                      {/* Page Buttons */}
                      <div>
                        <button
                          className="btn btn-outline-primary me-2"
                          disabled={currentPage === 1}
                          onClick={() => setCurrentPage(currentPage - 1)}
                        >
                          Prev
                        </button>

                        <span className="fw-bold">
                          Page {currentPage} of {totalPages}
                        </span>

                        <button
                          className="btn btn-outline-primary ms-2"
                          disabled={currentPage === totalPages}
                          onClick={() => setCurrentPage(currentPage + 1)}
                        >
                          Next
                        </button>
                      </div>

                    </div>
                  </div>
                )}

              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadWrittenQuestion;